<template>
  <span>
    <strong>{{ serviceOptionItem.description }}</strong> - <span :class="{'text-primary' : showPricePrimary}">{{ formatPrice(serviceOptionItem.price) }}</span>
    {{ serviceOptionItem.item.baseQuantity == 1 ? (serviceOptionItem.unit === 'monthly' ? 'monatlich' : 'einmalig') : 'monatlich' }}{{getMinimumTermPeriodText()}}{{extraDescriptionText}}{{ hasDependency() && showProductDependencies ? ', zzgl.' : '' }} {{ additionalText }}
    <template v-if="hasDependency() && showProductDependencies">
      {{ getDependencies() }}
    </template>
    <template v-if="footNode !== ''"><sup class="text-primary">{{ footNode }}</sup></template>
  </span>
</template>

<script>
export default {
  name: "ServiceOptionItemText",
  props: {
    serviceOptionItem: Object,
    productDependencies: Array,
    showPricePrimary: {
      type: Boolean,
      default: false
    },
    showProductDependencies: {
      type: Boolean,
      default: true
    },
    additionalText: {
      type: String,
      default: ''
    },
    extraDescriptionText: {
      type: String,
      default: ''
    },
    footNode: {
      type: String,
      default: ''
    },
    addMinimumTermPeriod: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatPrice(price) {
      return new Intl.NumberFormat('de-DE', {style: 'currency', currency: 'EUR'}).format(price / 100)
    },
    hasDependency() {
      return this.serviceOptionItem.dependencies.length > 0

    },
    getDependencies() {
      if (this.serviceOptionItem.dependencies.length > 0) {
        let dependencyTexts = []

        for (let _serviceDependencyId of this.serviceOptionItem.dependencies) {
          let productDependency = this.getProductDependency(_serviceDependencyId)

          if (productDependency) {
            let text = this.formatPrice(productDependency.price) + ' ' + productDependency.description
            text += productDependency.mode === 'ONCE' ? ' (einmalig)' : ' (monatlich)'
            dependencyTexts.push(text);
          }
        }

        return dependencyTexts.join(", zzgl. ")

      }
    },
    getProductDependency(id) {
      for (let _productDependency of this.productDependencies) {
        if (_productDependency.id == id) {
          return _productDependency
        }
      }
    },
    getMinimumTermPeriodText(serviceOptionItem) {
      if (!this.addMinimumTermPeriod) return;

      let text = ', Mindestvertragslaufzeit ' + this.serviceOptionItem.item.baseQuantity + ' Monat'
      if (this.serviceOptionItem.item.baseQuantity > 1) text += 'e'

      return text
    }
  }
}
</script>

<style scoped>

</style>
